import styled from "styled-components";
import { Link, useLocation } from "react-router-dom";
import { theme } from "../theme";
import { imgs } from "../constants/imgConst";
import { gnbConst } from "../constants/gnbConst";
import { flexColumnCenter, flexStartCenter } from "../style/mixins";
import { useMemberStore } from "../store/memberStore";

export default function Gnb() {
  const location = useLocation();
  const { memberPermitLevel } = useMemberStore();

  return (
    <GnbLayout>
      <GnbLogo to={memberPermitLevel >= 100 ? "/dashboard" : "/notice"}>
        <img src={imgs.logo} alt="로고" />
      </GnbLogo>

      <GnbLinkBox>
        {gnbConst.map(obj => (
          memberPermitLevel >= obj.level &&
          <GnbItem
            to={obj.path}
            key={obj.path}
            $action={location.pathname.includes(obj.path) || location.search.includes(obj.path)}
          >
            <obj.icon />
            <p>{obj.title}</p>
          </GnbItem>
        ))}
      </GnbLinkBox>
    </GnbLayout>
  );
}

const GnbLayout = styled.nav`
  background-color: ${theme.color.primary};
`;

const GnbLogo = styled(Link)`
  display: block;
  padding: 1.5rem 0 1.5rem 1.5rem;
  margin-bottom: 2rem;
`;

const GnbLinkBox = styled.div`
  ${flexColumnCenter};
  gap: 0.375rem;
`;

const GnbItem = styled(Link) <{ $action: boolean; }>`
  background-color: ${({ $action }) => $action ? "#414DA1" : "transparent"};
  padding: .75rem 1rem .75rem 1.875rem;
  border-left: ${({ $action }) => $action ? "5px solid #fff" : "none"};
  ${flexStartCenter};
  gap: 1rem;
  transition: all 0.2s;

  p {
    color: #fff;
    line-height: 1;
  }

  &:hover {
    background-color: #414DA1;
  }
`;